export const roomConstants = {
    POSTROOM_REQUEST: 'POST_ROOM_REQUEST',
    GETROOMS_REQUEST: 'GET_ROOMS_REQUEST',
    GETROOM_REQUEST: 'GET_ROOM_REQUEST',
    POSTINVITATION_REQUEST: 'POST_INVITATION_REQUEST'
};
